(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Wyckid", [], factory);
	else if(typeof exports === 'object')
		exports["Wyckid"] = factory();
	else
		root["Wyckid"] = factory();
})(self, function() {
return 